// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__1ikFj","control":"Checkout_control__2z9h9","actions":"Checkout_actions__N1-9Q","submit":"Checkout_submit__2nWpV","invalid":"Checkout_invalid__3sji-"};